import { Logger, LoggerService } from "@Shared/logger";
import { SignInModalService } from "./services";

export class SignInModalModuleClass {
    private Logger: Logger = LoggerService.createLogger("SignInModalModuleClass");

    constructor() {
        this.Logger.trace("****  CTOR ****");
    }

    public async init(): Promise<void> {
        this.Logger.trace("setting up Sign In Modal Module...");
        try {
            await SignInModalService.Instance.init();
            return Promise.resolve();
        } catch (error) {
            throw error;
        }
    }

    public show(): Promise<void> {
        return SignInModalService.Instance.show();
    }

    public close(): void {
        SignInModalService.Instance.close();
    }
}

export const SignInModalModule = new SignInModalModuleClass();
